import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import ArticlesTiles from '@/creditflowresearch/ui/components/creditFlow/articles/ArticlesTiles';
import { IArticlesTilesProps } from '@/creditflowresearch/ui/components/creditFlow/articles/ArticlesTiles/ArticlesTiles';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';
import { useIsOpenAccessDeal } from '@/creditflowresearch/application/User/access/grants/OpenAccessDealContext';
import { useIsProfileLockedWithoutAddOn } from '@/creditflowresearch/application/User/access/hooks/useIsProfileLockedWithoutAddOn';
import ArticlesTilesFallback from './ArticlesTilesFallback';

interface IArticlesTilesWithFallbackProps extends IArticlesTilesProps {
  userAccessChecks: boolean[],
}

const ArticlesTilesWithFallback = (
  {
    userAccessChecks,
    ...otherProps
  }: IArticlesTilesWithFallbackProps,
) => {
  const { checkAccessByUserPlan, checkAccessByFeature, plan } = useUserPlanContext();
  // TODO: remove the deal-card clause when the European market opening period ends
  const isOpenAccessDeal = useIsOpenAccessDeal();
  // TODO: remove when the European market opening period ends
  const isProfileLocked = useIsProfileLockedWithoutAddOn();
  const granted = (useAccessGrant() || isOpenAccessDeal) && !isProfileLocked;
  const userAccessChecksExtended = granted
    ? [true]
    : [
    ...userAccessChecks,
    checkAccessByUserPlan(UserPlanType.PREMIUM),
    checkAccessByFeature(UserPlanFeature.CommentaryAndDealFlow),
    ];

  return (
    <CheckUserAccess
      conditions={ [
        {
          checks: [granted || !UserPlan.isUnauthorized(plan)],
          fallback: <ArticlesTilesFallback />,
        },
        {
          checks: userAccessChecksExtended,
          fallback: <ArticlesTilesFallback isAuthorized />,
        },
      ] }
    >
      <ArticlesTiles { ...otherProps } />
    </CheckUserAccess>
  );
};

export default ArticlesTilesWithFallback;
